import { Back, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";

import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffect";
import * as Topics from "../Data/Topics";
import * as VO from "../Data/VoiceOver";

import { Button } from "./Button";

export default class PhotoButton extends Button {
    public get name() { return "PhotoButton"; }
    private _showTween?: TweenLite;
    private _attractTween?: TweenMax;
    private readonly _subscriptions: any[];

    constructor(pCallback: () => void) {
        super(pCallback, "camera-button-glow", Constants.SPRITESHEET_UI, VO.U18, SFX.UI_CLICK);
        this._subscriptions = [
            PubSub.subscribe(Topics.POWERUP_THREE_UNLOCKED, this.Show.bind(this)),
        ];

        this.visible = false;
    }

    public Show() {
        Application.instance.audio.play(SFX.CAMERA_BUTTON_APPEAR, 1, false, HLF.AudioCategory.SFX);
        this.visible = true;
        this._showTween = TweenLite.from(this, 1, {
            pixi: {
                scaleX: 0,
                scaleY: 0,
            },
            ease: Back.easeOut.config(1.6),
        });
        this._showTween.eventCallback(Constants.TWEEN_ONCOMPLETE, () => {
            PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this);
            this._attractTween = TweenMax.to(this, 0.5, {pixi: {scaleX: 1.05, scaleY: 1.05}}).repeat(-1).yoyo(true);
        });
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
        this._showTween?.kill();
    }

    public onFocusBegin() {
        this._attractTween?.pause();
        super.onFocusBegin();
    }

    public onFocusEnd() {
        super.onFocusEnd();
        this._attractTween?.resume(0);
    }

    protected onPointerOver(pEvent: PIXI.interaction.InteractionEvent) {
        this._attractTween?.pause();
        super.onPointerOver(pEvent);
    }

    protected onPointerOut(pEvent: PIXI.interaction.InteractionEvent) {
        super.onPointerOut(pEvent);
        this._attractTween?.resume(0);
    }
}
